// store/modelSlice.js
import { createSlice } from '@reduxjs/toolkit';

const modelSlice = createSlice({
  name: 'model',
  initialState: {
    selectedModel: null,
    selectedMode: 'global',  // <-- default mode
    modelSelectedOnce: false,
  },
  reducers: {
    setSelectedModel: (state, action) => {
      state.selectedModel = action.payload;
      if (!state.modelSelectedOnce) {
        state.modelSelectedOnce = true;
      }
    },
    setSelectedMode: (state, action) => {
      state.selectedMode = action.payload;
    },
  },
});

export const { setSelectedModel, setSelectedMode } = modelSlice.actions;
export default modelSlice.reducer;
